import ThemeProvider from './ThemeProvider';
import { lendingClubPalette } from './palette';
export { lendingClubPalette };
export default ThemeProvider;
